export default __webpack_public_path__ + "static/media/car-bg.1757e640.jpg";